var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("screen-header", {
        attrs: { updateTime: _vm.updateTime },
        on: { "update-data": _vm.updateData }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "city-basic" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "city-basic-data" },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("县市区")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.cities.length - 2 || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("个")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("学校")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.basicData.schoolCount || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("所")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("班级(总数)")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.basicData.totalClassCount || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("个")])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.$regional.HengshuiYanshou
                    ? _c("el-col", { attrs: { span: 6 } }, [
                        _c("span", [_vm._v("班级(55人以上)")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "special-data-font" }, [
                            _vm._v(_vm._s(_vm.basicData.largeClassCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("个")])
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "40px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("教师")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.basicData.teacherCount || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("人")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("学生")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.basicData.studentCount || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("人")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("男生")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.basicData.boyCount || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("人")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("span", [_vm._v("女生")]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", { staticClass: "data-font" }, [
                        _vm._v(_vm._s(_vm.basicData.girlCount || 0))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("人")])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "charts" }, [
            _c("div", {
              staticStyle: { width: "25vw" },
              attrs: { id: "main" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rest-city" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.clickCity("市直属")
                      }
                    }
                  },
                  [_vm._v("市直属")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.clickCity("滨湖新区")
                      }
                    }
                  },
                  [_vm._v("滨湖新区")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.clickCity("高新区")
                      }
                    }
                  },
                  [_vm._v("高新区")]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "stage-basic" },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "top-select" }, [
              _c("div", { staticClass: "stage-select" }, [
                _c(
                  "div",
                  { staticStyle: { "line-height": "18px" } },
                  [
                    _c("span", [_vm._v("选择学段：")]),
                    _vm._v(" "),
                    _vm._l(_vm.stages, function(item) {
                      return _c(
                        "span",
                        {
                          key: item.value,
                          class:
                            _vm.stage === item.value
                              ? "school-stage active"
                              : "school-stage",
                          on: {
                            click: function($event) {
                              return _vm.changeStage(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-top": "20px", "line-height": "18px" }
                  },
                  [
                    _c("span", [_vm._v("选择区域：")]),
                    _vm._v(" "),
                    _vm._l(_vm.cities, function(item) {
                      return _c(
                        "span",
                        {
                          key: item.value,
                          class:
                            _vm.city === item.value
                              ? "school-stage active"
                              : "school-stage",
                          on: {
                            click: function($event) {
                              return _vm.changeCity(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stage-data" },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 3 } }, [
                        _c("span", [_vm._v("学校")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "data-font" }, [
                            _vm._v(_vm._s(_vm.pageData.schoolCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("所")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 3 } }, [
                        _c("span", [_vm._v("班级(总数)")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "data-font" }, [
                            _vm._v(_vm._s(_vm.pageData.totalClassCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("个")])
                        ])
                      ]),
                      _vm._v(" "),
                      !_vm.$regional.HengshuiYanshou
                        ? _c("el-col", { attrs: { span: 3 } }, [
                            _c("span", [_vm._v("班级(55人以上)")]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { "margin-top": "10px" } }, [
                              _c("span", { staticClass: "special-data-font" }, [
                                _vm._v(
                                  _vm._s(_vm.pageData.largeClassCount || 0)
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("个")])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 3 } }, [
                        _c("span", [_vm._v("教师")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "data-font" }, [
                            _vm._v(_vm._s(_vm.pageData.teacherCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("人")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", [_vm._v("学生")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "data-font" }, [
                            _vm._v(_vm._s(_vm.pageData.studentCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("人")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", [_vm._v("男生")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "data-font" }, [
                            _vm._v(_vm._s(_vm.pageData.boyCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("人")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", [_vm._v("女生")]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", { staticClass: "data-font" }, [
                            _vm._v(_vm._s(_vm.pageData.girlCount || 0))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("人")])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "home-table",
                            attrs: {
                              data: _vm.pageData.schoolSummaryList,
                              size: "medium",
                              border: "",
                              "header-row-style": { color: "#fff" },
                              "row-style": { height: "40px" }
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "index",
                                label: "序号",
                                width: "80"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(scope.$index + 1) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _vm.city
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "schoolName",
                                    label: "学校名称"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.city
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "regionName",
                                    label: "区县名称"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.city
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "schoolNumber",
                                    label: "学校（总数）"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "totalClassCount",
                                label: "班级(总数)"
                              }
                            }),
                            _vm._v(" "),
                            !_vm.$regional.HengshuiYanshou
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "largeClassCount",
                                    label: "班级(55人以上)"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "teacherCount", label: "教师数" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "studentCount", label: "学生数" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "boyCount", label: "男生数" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "girlCount", label: "女生数" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "screen-pagination-row screen-pagination" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _vm.city
                      ? _c("el-pagination", {
                          attrs: {
                            total: _vm.total,
                            "current-page": _vm.page,
                            "page-sizes": [10, 20, 100],
                            "page-size": _vm.size,
                            layout: "prev, pager, next, sizes, jumper"
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.page = $event
                            },
                            "update:current-page": function($event) {
                              _vm.page = $event
                            },
                            "update:pageSize": function($event) {
                              _vm.size = $event
                            },
                            "update:page-size": function($event) {
                              _vm.size = $event
                            },
                            "current-change": function(val) {
                              return _vm.initStageData(
                                this$1.stage,
                                this$1.city,
                                val,
                                this$1.size
                              )
                            },
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "city-basic-title" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/big-screen/city-basic-left.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "city-basic-title-font" }, [
        _vm._v("全市基本情况统计")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../assets/big-screen/city-basic-right.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stage-basic-title" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/big-screen/city-basic-left.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "city-basic-title-font" }, [
        _vm._v("全市 各学段基本情况统计")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../assets/big-screen/city-basic-right.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-09517b0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-09517b0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/big-screen/Index.vue
// module id = null
// module chunks = 